import React, { Component, useState } from "react";
import Footer from "../Layout/Footer/Footer";
import Header from "../Layout/Header/Header";
import Prize_winners from "./Prizes/Prize_winners";
import About_puzzled from "./About-us/About_puzzled";
import Poweredby_after from "./Powered-by/Poweredby_after";
import welcome_img from "../../Assets/img/welcome.svg";
import edition01 from "../../Assets/img/edition_01.svg";
import edition02 from "../../Assets/img/edition_02.svg";
import edition03 from "../../Assets/img/edition_03.svg";
import img2 from "../../Assets/img/Group 10.svg";
import Registration from "../Components/Registration/Registration";
import Editions from "./Editions";
import Topbar from "../Layout/Header/Topbar";
class Welcome extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="welcome innerBody">
        <Topbar />
        <Header/>
        <div className="container Register login ">
          <div className="row">
            <div className="col-lg-7 col-md-12 col-12">
              <div className="mt-4 mb-5">
                <div className="card-body">
                  <div className="row justify-content-center pt-6">
                    <div className="col register_form">
                      <div className="login-form pl-4 pr-4">
                        <div className="login-right">
                          <h3 className="pb-3 text-left">
                            {" "}
                            Welcome to Puzzled{" "}
                          </h3>
                          <p>
                            Do you love to solve puzzles ? Do you want to challenge yourself against the best in the business?  You are at the right place. 

                            Register to participate in our showpiece event.
                          </p>
                        </div>

                        <Registration />
                      </div>
                    </div>
                  </div>
                  <br />
                </div>
              </div>
            </div>

            <div className="col-lg-5 col-md-12 col-12 login-right  justify-content-center text-center pt-5">
              <br />
              <img src={welcome_img} alt="" style={{ width: "100%" }} />
            </div>
          </div>
        </div>

        <div className="container prize_winners">
          <h3 className="pb-3 text-center"> PRIZES </h3>
          <Prize_winners />
        </div>

        {/* <div className="container">
          <div className="pt-5 pb-5 previous_editions">
            <div className="row pb-4">
              <div className="col-md-7">
                <h3 className="text-right text-xs-center">
                  {" "}
                  PREVIOUS EDITIONS{" "}
                </h3>
              </div>

              <div className="col-md-5 text-right text-xs-center">
                <a href="/editions"> View All Editions {">"} </a>
              </div>
            </div>

            <p className="pb-3 text-center">
                We host events every few months. If you feel that you are out of touch, you can always play our old editions and get the experience of puzzled. For future events, please 
               leave your email and we will notify you a week before the edition goes live. Don't miss out on the thrill of competing in a live event.
            </p>
            <Editions
                   noHeader="true"
                   noTitle="true"
                   noFooter="true" />
            </div>
        </div> */}

        <div className="intro py-lg-9 position-relative text-white">
          <div className="pt-md-11">
            <div className="container pt-3">
              <div className="row align-items-center">
                <div className="col-12 col-md-12 col-lg-7 order-md-2">
                  <img
                    src={img2}
                    className="img-fluid mw-md-150 mw-lg-130 mb-6 mb-md-0"
                    alt="..."
                  />
                </div>
                <div className="col-lg-5 col-md-12 col-12">
                  <h2 className="title text-light">
                    <span> WHO ARE WE ?</span>
                  </h2>
                  <p className="mt-3">
                    Puzzled has been conceptualized and created by a team of
                    puzzling enthusiasts, who have literally cracked every
                    online puzzling event in the past decade. The passion for
                    puzzling led us to create something to give back to the
                    immensely fluttery puzzling community. Our success in this
                    venture gets closer to fulfillment every time you feel the
                    pride in solving each level we have designed for you!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <About_puzzled />
        <div className="mt-4">
          {" "}
          <h3 className="text-center text-light"> POWERED BY </h3>{" "}
          <Poweredby_after />{" "}
        </div>
        <Footer/>
      </div>
    );
  }
}

export default Welcome;
